module.exports = __webpack_public_path__ + "img/character.3d1678be.png";